export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '7a001aec-c92a-4154-a6fa-33e77918be9b';
export const MODAL_CLOSE_SEC = 2.5;